let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("am034")).then(() => parcelRequire('370nS'));